'use strict';

var defineProperty = require('../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var withHCUIExperiment = function withHCUIExperiment(experimentOptions) {
  return function (DefaultComponent) {
    var ExperimentalComponent = experimentOptions.ExperimentalComponent,
        experimentName = experimentOptions.experimentName,
        experimentVariantName = experimentOptions.experimentVariantName,
        experimentFn = experimentOptions.experimentFn;
    var WithHCUIExperiment = React.forwardRef(function WithHCUIExperiment(props, ref) {
      var _experimentFn = experimentFn({
        experimentName: experimentName,
        experimentVariantName: experimentVariantName
      }),
          isExperimentActive = _experimentFn.isExperimentActive;

      if (isExperimentActive) {
        return React__default["default"].createElement(ExperimentalComponent, _objectSpread({}, props, {
          ref: ref
        }));
      }

      return React__default["default"].createElement(DefaultComponent, _objectSpread({}, props, {
        ref: ref
      }));
    });
    return WithHCUIExperiment;
  };
};

module.exports = withHCUIExperiment;
